import React, { useEffect, useState } from 'react';
import 'twin.macro';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Button } from '../button';
import { Icon } from '../icon';
import { LoaderIcon } from 'icons';
import { Input, Select, TextArea } from './FormParticals';
import { getExternalHref, loginRegisterOptions, receiverMailOptions } from '../../data/contactform';
import { submitContactForm } from 'services/user';
import { Notification } from '../notifications';
import { useUnmounted } from '../common/hooks';
import { settings } from '../../settings';
import { openExternalHref } from '../../lib/helpers';
import { Small } from '../text';

export const ContactForm = (props) => (
  <GoogleReCaptchaProvider reCaptchaKey={settings.RECAPTCHA_SITE_KEY}>
    <ContactFormWithCaptcha {...props} />
  </GoogleReCaptchaProvider>
);

const ContactFormWithCaptcha = ({ selectedOption = 0, selectedProblem = 0 }) => {
  const [receiverMail, setReceiverMail] = useState(receiverMailOptions[selectedOption].value);
  const [loginRegisterProblem, setLoginRegisterProblem] = useState(
    loginRegisterOptions[selectedProblem].value,
  );
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNum, setPhoneNum] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({});
  const unmounted = useUnmounted();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const selected = () => {
    if (receiverMail !== '' && receiverMail === 'gdpr') {
      return receiverMail;
    } else if (receiverMail === 'problem' && loginRegisterProblem !== '') {
      return loginRegisterProblem;
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let recaptcha = '';
      if (executeRecaptcha) {
        recaptcha = await executeRecaptcha('contact');
      }
      await submitContactForm({
        name,
        sender: email,
        phone: phoneNum,
        description,
        subject: receiverMail,
        recaptcha,
      });
      if (!unmounted.current) {
        setName('');
        setEmail('');
        setPhoneNum('');
        setDescription('');
        setNotification({ state: 'success', message: 'Succes' });
      }
    } catch (error) {
      if (!unmounted.current) {
        if (error.response && error.response.status === 403) {
          setNotification({ state: 'error', message: 'Timeout' });
        } else {
          setNotification({ state: 'error', message: 'error' });
        }
      }
    } finally {
      if (!unmounted.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (selected()) {
      openExternalHref(getExternalHref(selected()));
    }
  }, [loginRegisterProblem, receiverMail]);

  useEffect(() => {
    if (receiverMail !== 'problem') {
      setLoginRegisterProblem(loginRegisterOptions[0].value);
    }
  }, [receiverMail]);

  return (
    <form onSubmit={submit}>
      {notification.state && (
        <Notification
          message={notification.message}
          style={notification.state}
          onClick={() => setNotification({})}
          tw='mb-4'
        />
      )}
      <Select
        options={receiverMailOptions}
        requiredField
        name='contactform_receiver_mail'
        onChange={(e) => setReceiverMail(e.target.value)}
        selected={receiverMail}
      />
      {receiverMail === 'problem' && (
        <Select
          options={loginRegisterOptions}
          requiredField
          name='contactform_login_register_problem'
          onChange={(e) => setLoginRegisterProblem(e.target.value)}
        />
      )}
      {((receiverMail === 'problem' && loginRegisterProblem !== '') || receiverMail === 'gdpr') && (
        <>
          <small>
            <strong>LET OP:</strong> er wordt een nieuwe pagina geopend. Wordt er geen pagina
            geopend controleer dan of pop-ups worden geblokkeerd. Is dat niet het geval, klik dan op
            onderstaande button:
          </small>
          <a
            href={getExternalHref(selected())}
            target='_blank'
            rel='noopener noreferrer'
            tw='block mt-2'
          >
            <Button primary label='Open link' />
          </a>
        </>
      )}
      {receiverMail !== 'problem' && receiverMail !== 'gdpr' && (
        <>
          <Input
            placeholder='Jouw naam'
            name='contactform_name'
            id='name'
            maxLength='150'
            value={name}
            onChange={(e) => setName(e.target.value)}
            requiredField
            label={name ? 'Naam' : ''}
          />
          <Input
            placeholder='E-mail'
            name='contactform_mail'
            id='email'
            type='email'
            maxLength='150'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            requiredField
            label={email ? 'E-mail' : ''}
          />
          <Input
            placeholder='Telefoonnummer'
            name='contactform_phone'
            id='phone'
            type='tel'
            maxLength='150'
            value={phoneNum}
            onChange={(e) => setPhoneNum(e.target.value)}
            label={phoneNum ? 'Telefoonnummer' : ''}
            autoComplete='off'
          />
          <TextArea
            placeholder='Beschrijving'
            name='description'
            id='description'
            rows='5'
            autoComplete='off'
            maxLength='500'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            label={description ? 'Beschrijving' : ''}
          />
          <Small tw='block -mt-2 pb-2'>{description.length} / 500 karakters</Small>
          <div tw='flex justify-end'>
            <Button
              type='submit'
              label={
                !loading ? (
                  'Verstuur'
                ) : (
                  <Icon Type={LoaderIcon} tw='animate-spin h-5' color='input-back' size='small' />
                )
              }
              primary
              disabled={loading}
            />
          </div>
        </>
      )}
    </form>
  );
};
